$(".custom_social_share_icon").click(function(){
  $(".custom_social_toggle").toggle();
});


/* Shopify Review App Adjustments*/
jQuery(document).ready(function(){  
	setTimeout(function(){
     
      //alert("OK");
      
      $('.custom_product_review_grid .spr-badge').each(function() {
	  //$('.spr-badge').each(function() {

          var get_rating_in_num = $(this).attr('data-rating');
          var get_rating_id = $(this).attr('id');
        //console.log(get_rating_in_num);
        //console.log(get_rating_id);
        
          //$("#"+get_rating_id+" .spr-starrating.spr-badge-starrating").css("display","none");
          if(get_rating_in_num>0){            
            get_rating_in_num = parseFloat(get_rating_in_num);
            get_rating_in_num = get_rating_in_num.toFixed(1);
            //alert("get_rating_id");
            $("#"+get_rating_id+" .spr-badge-starrating").addClass("custom_star_number_show");
            $("#"+get_rating_id+" .spr-badge-starrating").html(get_rating_in_num);
          }else{          
            $("#"+get_rating_id+" .spr-badge-starrating").removeClass("custom_star_number_show");
          }
      });

      
      
      $('.custom_collection_item_image .spr-badge').each(function() {
          var get_rating_in_num = $(this).attr('data-rating');
          var get_rating_id = $(this).attr('id');
        
          if(get_rating_in_num>0){            
            get_rating_in_num = parseFloat(get_rating_in_num);
            get_rating_in_num = get_rating_in_num.toFixed(1);
            //alert("get_rating_id");
            $("#"+get_rating_id+" .spr-badge-starrating").addClass("custom_star_number_show");
            $("#"+get_rating_id+" .spr-badge-starrating").html(get_rating_in_num);
          }else{          
            $("#"+get_rating_id+" .spr-badge-starrating").removeClass("custom_star_number_show");
          }
      });
      
	
     $('.custom_product_review .spr-badge').each(function() {
        var get_rating_in_num1 = $(this).attr('data-rating');
        var get_rating_id1 = $(this).attr('id');
      
        if(get_rating_in_num1>0){            
            get_rating_in_num1 = parseFloat(get_rating_in_num1);
            get_rating_in_num1 = get_rating_in_num1.toFixed(1);
          //alert("get_rating_id");
          $("#"+get_rating_id1+" .spr-badge-starrating").addClass("custom_star_number_show");
          $("#"+get_rating_id1+" .spr-badge-starrating").html(get_rating_in_num1);
        }else{          
          $("#"+get_rating_id1+" .spr-badge-starrating").removeClass("custom_star_number_show");
        }
      }); 
       //if(Math.floor(Math.random() * 50)>47)
        //  location.href = 'https://alhafidh.com';
      
	}, 4000);
});

$(document).ready(function(){
	setTimeout(function(){
    mobileMenuUpdate();
    removeDownload();
    toArabic();

      
      $('.custom_pdp_top_right_2 .spr-badge').each(function() {
          var get_rating_in_num2 = $(this).attr('data-rating');
          var get_rating_id2 = $(this).attr('id');
        
          if(get_rating_in_num2>0){            
            get_rating_in_num2 = parseFloat(get_rating_in_num2);
            get_rating_in_num2 = get_rating_in_num2.toFixed(1);
            $("#"+get_rating_id2+" .spr-badge-starrating").addClass("custom_star_number_show");
            $("#"+get_rating_id2+" .spr-badge-starrating").html(get_rating_in_num2);
          }else{ 
            $("#"+get_rating_id2+" .spr-starrating.spr-badge-starrating").css("display","none");
            $("#"+get_rating_id2+" .spr-badge-starrating").removeClass("custom_star_number_show");
          }
      });
      
	}, 2000);
});

//alert("Test");

$(document).ready(function(){
	setTimeout(function(){
    var current_url = window.location.href;
    //alert(current_url);
    var current_url_split = current_url.split('/');
    //alert(current_url_split);
    var current_url_include_ar = current_url_split.includes("en");
    //alert(current_url_include_ar);
    
    if(current_url_include_ar == false){
      //alert("Arabic Language");
      arabicTranslation();
    }
    
    function arabicTranslation(){
        
          
        if ($('.custom_pdp_top_right_2 .spr-badge-caption:contains("No reviews")').length > 0) {
            var no_reviews_text = $(".custom_pdp_top_right_2 .spr-badge-caption").text().replace("No reviews","لم يتم تقديم تعليقات");
            $(".custom_pdp_top_right_2 .spr-badge-caption").html(no_reviews_text); 
        }
        
        if ($('.custom_pdp_top_right_2 .spr-badge-caption:contains("reviews")').length > 0) {
            var reviews_text = $(".custom_pdp_top_right_2 .spr-badge-caption").text().replace("reviews","المراجعات");
            $(".custom_pdp_top_right_2 .spr-badge-caption").html(reviews_text); 
        }
        
        if ($('.custom_pdp_top_right_2 .spr-badge-caption:contains("review")').length > 0) {            
            var review_text = $(".custom_pdp_top_right_2 .spr-badge-caption").text().replace("review","مراجعة");
            $(".custom_pdp_top_right_2 .spr-badge-caption").html(review_text); 
        }      

        if ($('.custom_pdp_review_link:contains("Add Review")').length > 0) {   
          var rating_review = $(".custom_pdp_review_link").text().replace("Add Review","إضافة مراجعة");
          $(".custom_pdp_review_link").html(rating_review);
        }
      
        if ($('#shopify-product-reviews .spr-summary-actions-togglereviews:contains("reviews")').length > 0) {            
            var based_on_review_text = $("#shopify-product-reviews .spr-summary-actions-togglereviews").text().replace("reviews","المراجعات");
            $("#shopify-product-reviews .spr-summary-actions-togglereviews").html(based_on_review_text); 
        }   
        
        if ($('#shopify-product-reviews .spr-summary-actions-togglereviews:contains("review")').length > 0) {            
            var based_on_review_text = $("#shopify-product-reviews .spr-summary-actions-togglereviews").text().replace("review","مراجعة");
            $("#shopify-product-reviews .spr-summary-actions-togglereviews").html(based_on_review_text); 
        }
      
        if ($('#shopify-product-reviews .spr-summary-actions-togglereviews:contains("Based on")').length > 0) {   
          var based_on_review = $("#shopify-product-reviews .spr-summary-actions-togglereviews").text().replace("Based on","مرتكز على");
          $("#shopify-product-reviews .spr-summary-actions-togglereviews").html(based_on_review);
        }

        if ($('.templateProduct #shopify-product-reviews .spr-container .spr-summary .spr-summary-caption:contains("No reviews yet")').length > 0) {   
          //var No_reviews_yet = $(".templateProduct #shopify-product-reviews .spr-container .spr-summary .spr-summary-caption").text().replace("No reviews yet","لا توجد تعليقات حتى الآن");
          var No_reviews_yet = $(".templateProduct #shopify-product-reviews .spr-container .spr-summary .spr-summary-caption").text().replace("No reviews yet"," ");
          $(".templateProduct #shopify-product-reviews .spr-container .spr-summary .spr-summary-caption").html(No_reviews_yet);
        }
      

        if ($('.page-product .shipping-time .delivery-time strong:contains("Monday")').length > 0) {   
          var delivery_time_day_Monday = $(".page-product .shipping-time .delivery-time strong").text().replace("Monday","الثلاثاء");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Monday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Tuesday")').length > 0) {   
          var delivery_time_day_Tuesday = $(".page-product .shipping-time .delivery-time strong").text().replace("Tuesday","الثلاثاء");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Tuesday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Wednesday")').length > 0) {   
          var delivery_time_day_Wednesday = $(".page-product .shipping-time .delivery-time strong").text().replace("Wednesday","الأربعاء");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Wednesday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Thursday")').length > 0) {   
          var delivery_time_day_Thursday = $(".page-product .shipping-time .delivery-time strong").text().replace("Thursday","الخميس");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Thursday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Friday")').length > 0) {   
          var delivery_time_day_Friday = $(".page-product .shipping-time .delivery-time strong").text().replace("Friday","يوم الجمعة");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Friday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Saturday")').length > 0) {   
          var delivery_time_day_Saturday = $(".page-product .shipping-time .delivery-time strong").text().replace("Saturday","يوم السبت");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Saturday);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("Sunday")').length > 0) {   
          var delivery_time_day_Sunday = $(".page-product .shipping-time .delivery-time strong").text().replace("Sunday","الثلاثاء");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_day_Sunday);
        }
        
        if ($('.page-product .shipping-time .delivery-time strong:contains("January")').length > 0) {   
          var delivery_time_month_January = $(".page-product .shipping-time .delivery-time strong").text().replace("January","كانون الثاني");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_January);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("FebruaryFebruary")').length > 0) {   
          var delivery_time_month_February = $(".page-product .shipping-time .delivery-time strong").text().replace("February","شهر فبراير");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_February);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("March")').length > 0) {   
          var delivery_time_month_March = $(".page-product .shipping-time .delivery-time strong").text().replace("March","مارس");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_March);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("April")').length > 0) {   
          var delivery_time_month_April = $(".page-product .shipping-time .delivery-time strong").text().replace("April","أبريل");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_April);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("May")').length > 0) {   
          var delivery_time_month_May = $(".page-product .shipping-time .delivery-time strong").text().replace("May","مايو");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_May);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("June")').length > 0) {   
          var delivery_time_month_June = $(".page-product .shipping-time .delivery-time strong").text().replace("June","يونيو");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_June);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("July")').length > 0) {   
          var delivery_time_month_July = $(".page-product .shipping-time .delivery-time strong").text().replace("July","يوليو");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_July);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("August")').length > 0) {   
          var delivery_time_month_August = $(".page-product .shipping-time .delivery-time strong").text().replace("August","أغسطس");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_August);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("September")').length > 0) {   
          var delivery_time_month_September = $(".page-product .shipping-time .delivery-time strong").text().replace("September","سبتمبر");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_September);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("October")').length > 0) {   
          var delivery_time_month_October = $(".page-product .shipping-time .delivery-time strong").text().replace("October","اكتوبر");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_October);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("November")').length > 0) {   
          var delivery_time_month_November = $(".page-product .shipping-time .delivery-time strong").text().replace("November","شهر نوفمبر");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_November);
        }
        if ($('.page-product .shipping-time .delivery-time strong:contains("December")').length > 0) {   
          var delivery_time_month_December = $(".page-product .shipping-time .delivery-time strong").text().replace("December","ديسمبر");
          $(".page-product .shipping-time .delivery-time strong").html(delivery_time_month_December);
        }
      


        /*if ($('#tab_review_tabbed a.nav-link:contains("Add Review")').length > 0) {   
          var rating_review = $("#tab_review_tabbed a.nav-link").text().replace("Rating & Reviews","التقييم والمراجعات");
          $("#tab_review_tabbed a.nav-link").html(rating_review);
        }
      
        if ($('#shopify-product-reviews h2.spr-header-title:contains("Add Review")').length > 0) {   
          var Customer_reviews = $("#shopify-product-reviews h2.spr-header-title").text().replace("Customer Reviews","آراء المستهلكين");
          $("#shopify-product-reviews h2.spr-header-title").html(Customer_reviews);
        }
      
        if ($('#shopify-product-reviews a.spr-summary-actions-newreview:contains("Add Review")').length > 0) {   
          var write_a_review = $("#shopify-product-reviews a.spr-summary-actions-newreview").text().replace("Write a review","أكتب مراجعة");
          $("#shopify-product-reviews a.spr-summary-actions-newreview").html(write_a_review);
        }
      
        if ($('.floating_wl .floating_wl_content .floating-text:contains("Add Review")').length > 0) {   
          var floating_wishlist = $(".floating_wl .floating_wl_content .floating-text").text().replace("Wishlist","قائمة الرغبات");
          $(".floating_wl .floating_wl_content .floating-text").html(floating_wishlist);
        }
      
        if ($('#smile-lite-launcher-frame button > span:contains("Add Review")').length > 0) {   
          var floating_rewards = $("#smile-lite-launcher-frame button > span").text().replace("Rewards","المكافآت");
          $("#smile-lite-launcher-frame button > span").html(floating_rewards);
        }
      
        if ($('.page-product .shipping-time li.delivery-time:contains("Add Review")').length > 0) {   
          var want_it_delivery = $(".page-product .shipping-time li.delivery-time").text().replace("Want it delivered by","تريد تسليمها من قبل");
          $(".page-product .shipping-time li.delivery-time").html(want_it_delivery);
        }
      
        
        if ($('#shopify-product-reviews .spr-summary-actions-togglereviews:contains("Add Review")').length > 0) {   
          var based_on_review = $("#shopify-product-reviews .spr-summary-actions-togglereviews").text().replace("Based on","مرتكز على");
          $("#shopify-product-reviews .spr-summary-actions-togglereviews").html(based_on_review);
        }
        
            */

    }
      
	}, 2000);
});



function mobileMenuUpdate(){


  //move dishwashes to kitchen appliances
  xx  = document.querySelectorAll(".xx")[0];
  source  = xx.content.querySelectorAll(".mparent")[1]
  dist  = xx.content.querySelectorAll(".mparent")[0]
  dw    = source.querySelectorAll("ul div")[0]
  nxt  = dist.querySelectorAll("ul div")[0]
  par = dist.querySelectorAll("ul")[0]
  par.insertBefore(dw, nxt);
 
  
  //all tvs - link
  zz = document.querySelectorAll(".xxx")[0];
  zzz = zz.content.querySelectorAll(".gg")[0];
  zzz.classList.remove("dropdown-inner");

}
function toArabic(){
  try{
    a = document.querySelector(".jdgm-rev-widg__summary-text").innerText;
    document.querySelector(".jdgm-rev-widg__summary-text").innerText = "";
    b = a.match(/\d+/);    
    if(b>0){
    document.querySelector(".jdgm-rev-widg__summary-text").innerText = b + " تقييم ";
    }

} catch(_){}


}


function removeDownload(){
  try{
  if( !document.querySelector(".downloadfile-list a").href.includes("pdf")){
    document.querySelector(".downloadfile-list a").style.display="none";
    document.querySelectorAll(".nav-tabs li.nav-item")[2].style.display="none";
  }
} catch(_){}


}